import Model, { encoders, ID } from 'src/models/model'
import PriceTier from 'src/models/price-tier/PriceTier'

export default class PriceTierPrice extends Model {
  static name = 'PriceTierPrice'

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Concession]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      price: {
        type: Number,
        encode: encoders.cents,
        default: null
      },
      priceTier: {
        type: PriceTier,
        reference: true
      }
    }
  }
}
